import { useBrandAndTheme } from 'components/helpers/ContextProvider/BrandAndThemeContext';
import { FeatureDecor as FeatureBettyCrocker } from './FeatureDecor.brand.bettycrocker';
import { FeatureDecor as FeaturePillsbury } from './FeatureDecor.brand.pillsbury';
import { FeatureDecor as FeatureDefault } from './FeatureDecor.brand.default';
import { FeatureDecor as FeatureWhiteLabel } from './FeatureDecor.brand.whitelabel';
import { FeatureDecor as FeatureGMI } from './FeatureDecor.brand.gmi';

export const FeatureDecor = () => {
  const { brand } = useBrandAndTheme();

  switch (brand) {
    case 'BrandsBettyCrocker':
      return <FeatureBettyCrocker />;
    case 'BrandsPillsbury':
      return <FeaturePillsbury />;
    case 'BrandsWhiteLabel':
      return <FeatureWhiteLabel />;
    case 'BrandsGMI':
      return <FeatureGMI />;
    default:
      return <FeatureDefault />;
  }
};
